// extracted by mini-css-extract-plugin
module.exports = {"itemArrow":"TrendArrow_itemArrow__PjLMD","positive":"TrendArrow_positive__WUhGL","negative":"TrendArrow_negative__287GI"};